var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"flex flex-wrap items-stretch"},[_c('CommunicationsList',{attrs:{"page":_vm.page,"status":_vm.status,"types":_vm.types,"category-slug":_vm.categorySlug},on:{"loaded":(loaded) => { _vm.communicationsLoaded = loaded }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }